import { render, staticRenderFns } from "./UnReadMore.vue?vue&type=template&id=7a82636d&lang=pug&"
import script from "./UnReadMore.vue?vue&type=script&lang=js&"
export * from "./UnReadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports